import { PricesView } from './components';
import { SignupSuccess } from './components';
import { SignupVerify } from './components';
import { TeaserSmallBody } from './components';
import { GdprPrivacyManager } from 'volto-gdpr-privacy';
import RenewView from './components/Blocks/Renew/View';
import RenewSchema from './components/Blocks/Renew/Schema';
import SignupBlockView from './components/Blocks/Signup/View';
import SignupBlockSchema from './components/Blocks/Signup/Schema';
import AppListUploadView from './components/Blocks/AppListUpload/View';
import AppListUploadEdit from './components/Blocks/AppListUpload/Edit';
import AppListUploadSchema from './components/Blocks/AppListUpload/Schema';
import PortknoxPlansView from './components/Blocks/PortknoxPlans/View';
import PortknoxPlansSchema from './components/Blocks/PortknoxPlans/Schema';

import imagesSVG from '@plone/volto/icons/images.svg';
const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    isMultilingual: true,
    supportedLanguages: ['de', 'en'],
    defaultLanguage: 'de',
    showTags: false,
    siteTitleFormat: {
      includeSiteTitle: true,
      titleAndSiteTitleSeparator: '-',
    },
    appExtras: [
      ...config.settings.appExtras,
      {
        match: '',
        component: GdprPrivacyManager,
      },
    ],
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      url: 'https://portknox.net',
      sameAs: [
        'https://bsky.app/profile/portknox.bsky.social',
        'https://mastodon.xyz/@portknox',
        'https://x.com/portknox_net',
        'https://www.instagram.com/portknox_net/',
        'https://www.linkedin.com/company/portknox',
        'https://www.facebook.com/PortKnox.net/',
      ],
      logo: 'https://portknox.net/@@site-logo/logo_portknox.svg',
      name: 'Portknox.net',
      description: 'Nextcloud Hosting aus Deutschland',
      email: 'info@portknox.net',
      telephone: '+49-251-59067248',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Lublinring 12',
        addressLocality: 'Münster',
        addressCountry: 'DE',
        addressRegion: '',
        postalCode: '48147',
      },
      vatID: 'DE270822679',
    },
  };
  config.addonRoutes.push({ path: '/**/prices', component: PricesView });
  config.addonRoutes.push({
    path: '/**/signup-success',
    component: SignupSuccess,
  });
  config.addonRoutes.push({
    path: '/**/signup-verify',
    component: SignupVerify,
  });

  // Enable link-to field for Listing block
  config.blocks.blocksConfig.listing = {
    ...config.blocks.blocksConfig.listing,
    showLinkMore: true,
  };

  // Add small teaser variation
  if (config.blocks.blocksConfig.teaser) {
    const smallVariation = {
      id: 'small',
      isDefault: false,
      title: 'Small',
      template: TeaserSmallBody,
    };

    // Add to main teaser block configuration
    config.blocks.blocksConfig.teaser.variations = [
      ...(config.blocks.blocksConfig.teaser.variations || []),
      smallVariation,
    ];

    // Add to Grid Block's teaser block configuration if it exists
    if (config.blocks.blocksConfig.gridBlock?.blocksConfig?.teaser) {
      config.blocks.blocksConfig.gridBlock.blocksConfig.teaser.variations = [
        ...(config.blocks.blocksConfig.gridBlock.blocksConfig.teaser
          .variations || []),
        smallVariation,
      ];
    }
  }

  // This uses a custom component to render the view
  // Uses the default edit form to render the edit form
  config.blocks.blocksConfig.renew = {
    id: 'renew',
    title: 'Renew ',
    view: RenewView,
    // edit: null;
    blockSchema: RenewSchema,
    icon: imagesSVG,
    sidebarTab: 1,
    group: 'common',
  };
  config.blocks.blocksConfig.signup = {
    id: 'signup',
    title: 'Signup',
    view: SignupBlockView,
    // edit: null;
    blockSchema: SignupBlockSchema,
    icon: imagesSVG,
    sidebarTab: 1,
    group: 'common',
  };
  config.blocks.blocksConfig.gridBlock.allowedBlocks.push('signup');
  config.blocks.blocksConfig.gridBlock.blocksConfig = {
    ...config.blocks.blocksConfig.gridBlock.blocksConfig,
    signup: config.blocks.blocksConfig.signup,
  };

  // AppList upload block
  config.blocks.blocksConfig.applistupload = {
    id: 'applistupload',
    title: 'AppList Upload',
    view: AppListUploadView,
    edit: AppListUploadEdit,
    blockSchema: AppListUploadSchema,
    icon: imagesSVG,
    sidebarTab: 1,
    group: 'common',
  };

  // Portknox Plans block
  config.blocks.blocksConfig.portknoxplans = {
    id: 'portknoxplans',
    title: 'Portknox Plans',
    view: PortknoxPlansView,
    blockSchema: PortknoxPlansSchema,
    icon: imagesSVG,
    sidebarTab: 1,
    group: 'common',
  };

  return config;
};

export default applyConfig;
